import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { AssessmentCompetencyGraphicResultApiObject } from '@qaroni-shared/types/assessment-competency-graphic-result-response';

@Injectable({
  providedIn: 'root',
})
export class AssessmentGraphicsResultsHttpService {
  private http = inject(HttpClient);

  public assessmentTypeCompetenciesResults$(
    companyID: number,
    assessmentID: number,
    employeeID: number
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/evaluations/${assessmentID}/employees/${employeeID}/stats/results`;
    return this.http.get<AssessmentCompetencyGraphicResultApiObject>(url, {
      observe: 'response',
    });
  }

  public responsableEmployeeEvaluationTypeResults$(
    employeeID: number,
    evaluationID: number,
    responsableID: number
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/evaluations/${evaluationID}/responsables/${responsableID}/evaluators/stats/results`;
    return this.http.get<AssessmentCompetencyGraphicResultApiObject>(url, {
      observe: 'response',
    });
  }

  public employeeEvaluationTypeResults$(
    employeeID: number,
    evaluationID: number
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/evaluations/${evaluationID}/evaluators/stats/results`;
    return this.http.get<AssessmentCompetencyGraphicResultApiObject>(url, {
      observe: 'response',
    });
  }
}
